import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { AssetsClassification } from "../assets-classification/assets-classification-entity";
import { AssetsSubCatagory } from "../assets-sub-catagory/assets-sub-catagory-entity";

@Entity('asset_category')
export class AssetsCatagory {

    @PrimaryGeneratedColumn("increment", { name: 'asset_category_id' })
    assetsCatagoryId : number;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "category_name"
    })
    assetsCatagoryName: string;

    @Column("varchar", {
        nullable: true,
        name: "assets_classification_id"
    })
    assetsClassificationId: number;

    @Column("boolean", {
        name: "is_active",
        default: true
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    // @ManyToOne(type => AssetsClassification, assetsClassification => assetsClassification.assetsCatagoryInfo, { nullable: false, })
    // @JoinColumn({ name: "assets_classification_id" })
    // assetsClassificationInfo: AssetsClassification;
    @OneToMany(type => AssetsCatagory, assetsCatagory => assetsCatagory.assetsSubCatagoryInfo)
    assetsSubCatagoryInfo: AssetsSubCatagory[];
    // @OneToMany(type => AssetsCatagory, assetsCatagory => assetsCatagory.openAssetsInfo)
    // openAssetsInfo: OpenAssets[];

}